import SHeading from "@/components/atoms/SHeading";
import SFeatureCard from "@/components/molecules/SFeatureCard";
import { featureSboxVn } from "@/constants";
import React from "react";
import { useTranslation } from "react-i18next";

const WhySnapBoxVietNam: React.FC = () => {
  const { t } = useTranslation();
  // const teamMembers = t("team_members", { returnObjects: true }) as Record<string, TeamMember[]>;
  const renderDescription = (description: string | string[]) => {
    if (!Array.isArray(description)) return description;

    return (
      <ul className="list-disc pl-5">
        {description.map((desc, idx) => (
          <li key={`desc-${idx}`} className="mt-2">
            {desc}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="flex flex-col">
      <SHeading
        tAlign="center"
        text={t("home.why_snap_box_vietnam")}
        className="font-extrabold md:text-3xl text-2xl"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12 ">
        {featureSboxVn(t).map((value, index) => (
          <SFeatureCard
            key={index}
            heading={value.heading}
            description={renderDescription(value.description)}
            icon={value.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default WhySnapBoxVietNam;
